/** The games whose images stand in for a thumbnail style, and the url one of those images is served from. */

export interface AssetDimensions {
  width: number;
  height: number;
}

export interface AssetSample {
  game: string;
  studio: string;
}

/**
 * The substitutions mirror `generateImgUrl` in
 * `frontend/player-frontend/src/casino/CasinoActions.ts` — the players' urls are built there, so a
 * divergence here would measure and preview an image nobody is ever served. `$studioname` is
 * replaced before `$studio` because the shorter token is a prefix of the longer one.
 */
export function resolveAssetUrl(template: string, sample: AssetSample): string {
  return template
    .replace(/\$studioname/g, encodeURIComponent(sample.studio).replace(/'/g, "%27"))
    .replace(/\$studio/g, sample.studio.replace(/[^a-z0-9]/gi, "").toLowerCase())
    .replace(/\$game/g, sample.game.replace(/[^a-z0-9]/gi, "").toLowerCase());
}
